import Oidc from 'oidc-client';
import _ from 'lodash';
import appConfig from 'react-global-configuration';

const defaults = {
    client_id: 'skytcadmin',
    post_logout_redirect_uri: `${window.location.protocol}//${window.location.hostname}${
        window.location.port ? `:${window.location.port}` : ''
    }/`,
    redirect_uri: `${window.location.protocol}//${window.location.hostname}${
        window.location.port ? `:${window.location.port}` : ''
    }/#/callback?`,
    response_type: 'id_token token',
    scope: 'read write profile openid skyslope primeapi skyslopeapi',
};

let OIDCClient = function(config) {
    config = config || {};
    config.authority = appConfig.get('SS_AUTH_URL');
    return new Oidc.OidcClient(_.defaults(config, defaults));
};

export default OIDCClient;



// WEBPACK FOOTER //
// ./src/utils/oidc-client.js